module.exports = "<p-card header=\"{{header}}\">\r\n  <p-chart type=\"bar\" [data]=\"bar\" [options]=\"options\"></p-chart>\r\n</p-card>"